// modeIcons.tsx - Shared SVG icon factory for navigation/session modes.
// One-file-one-responsibility: this file owns the MODE_ICONS map only.
// Imported by TabBar.tsx, TopChrome.tsx, and OnboardingTour.tsx.

import type { JSX } from 'react';

// Current product IA icon keys (V29 S8: the legacy 'home'/'studia'/'allena'/
// 'profilo' glyphs had no remaining consumer after the drawer retirement).
export type ModeKey = 'progresso' | 'simula' | 'chiedi' | 'appendice' | 'messaggi';

// V29 S1: icons take an optional pixel size (default 16 — the historical
// chrome/drawer size). The TabBar renders them at 22.
export const MODE_ICONS: Record<ModeKey, (color: string, size?: number) => JSX.Element> = {
  // W5 Session 1: simple ring/donut chart glyph for "Il mio progresso".
  // Same line-icon weight as the other drawer entries (1.6 stroke).
  progresso: (c, s = 16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="10" cy="10" r="6"/>
      <path d="M10 4a6 6 0 016 6"/>
    </svg>
  ),
  simula: (c, s = 16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="10" cy="10" r="7"/><path d="M10 6v4l2.5 2.5"/>
    </svg>
  ),
  chiedi: (c, s = 16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 6a2 2 0 012-2h8a2 2 0 012 2v5a2 2 0 01-2 2h-3l-3 3v-3H6a2 2 0 01-2-2V6z"/>
    </svg>
  ),
  appendice: (c, s = 16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 3h9a3 3 0 013 3v11H7a3 3 0 01-3-3V3z"/><path d="M4 14a3 3 0 013-3h9"/>
    </svg>
  ),
  messaggi: (c, s = 16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 5h14v9a1 1 0 01-1 1H6l-3 3V5z"/>
    </svg>
  ),
};
